import { formatPhoneNumber } from './Formatters';
import { FormErrors } from 'src/model/FormErrors';

export const createInputChangeHandler = (setFormData: Function, setErrors: Function, errorField: keyof FormErrors) => {
    return (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        if (name.includes('.')) {
            const [parent, field] = name.split('.');
            setFormData((prev: any) => ({
                ...prev,
                [parent]: { ...prev[parent], [field]: value }
            }));
            setErrors((prev: any) => ({ ...prev, [errorField]: false }));
        } else {
            setFormData((prev: any) => ({ ...prev, [name]: value }));
            setErrors((prev: any) => ({ ...prev, [errorField]: false }));
        }
    };
};

export const createPhoneChangeHandler = (setFormData: Function, setErrors: Function, errorField: keyof FormErrors) => {
    return (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const input = e.target;
        const cursorPosition = input.selectionStart || 0;
        const oldValue = input.value;
        const formatted = formatPhoneNumber(value);
        
        if (name.includes('.')) {
            const [parent, field] = name.split('.');
            setFormData((prev: any) => ({ ...prev, [parent]: { ...prev[parent], [field]: formatted } }));
            setErrors((prev: any) => ({ ...prev, [errorField]: false }));
        } else {
            setFormData((prev: any) => ({ ...prev, [name]: formatted }));
            setErrors((prev: any) => ({ ...prev, [errorField]: false }));
        }
        
        // Calculate new cursor position accounting for dashes
        setTimeout(() => {
            const digitsBeforeCursor = oldValue.slice(0, cursorPosition).replace(/\D/g, '').length;
            let newCursorPos = 0;
            let digitCount = 0;
            
            for (let i = 0; i < formatted.length && digitCount < digitsBeforeCursor; i++) {
                if (/\d/.test(formatted[i])) {
                    digitCount++;
                }
                newCursorPos = i + 1;
            }
            
            input.setSelectionRange(newCursorPos, newCursorPos);
        }, 0);
    };
};


export const createCheckboxChangeHandler = (setFormData: Function, setErrors: Function, errorField: keyof FormErrors) => {
    return (name: string, value: string) => {
        let newArray: string[];
        setFormData((prev: any) => {
            if (name.includes('.')) {
                const [parent, field] = name.split('.');
                const currentArray = prev[parent][field] as string[];
                newArray = currentArray.includes(value)
                    ? currentArray.filter((item: string) => item !== value)
                    : [...currentArray, value];
                return { ...prev, [parent]: { ...prev[parent], [field]: newArray } };
            } else {
                const currentArray = prev[name] as string[];
                newArray = currentArray.includes(value)
                    ? currentArray.filter((item: string) => item !== value)
                    : [...currentArray, value];
                return { ...prev, [name]: newArray };
            }
        });
        setErrors((prev: any) => ({ ...prev, [errorField]: newArray!.length === 0 }));
    };
};


export const createZipCodeChangeHandler = (setFormData: Function, setErrors: Function, errorField: keyof FormErrors) => {
    return (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name } = e.target;
        const digits = e.target.value.replace(/\D/g, '').slice(0, 5);
        if (name.includes('.')) {
            const [parent, field] = name.split('.');
            setFormData((prev: any) => ({ ...prev, [parent]: { ...prev[parent], [field]: digits } }));
        } else {
            setFormData((prev: any) => ({ ...prev, zipCode: digits }));
        }
        setErrors((prev: any) => ({ ...prev, [errorField]: false }));
    };
};
